// Copyright (c) 2021 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { concatMap, filter, throttleTime } from "rxjs/operators"
import * as Actions from "../actions"

export const onTimelineOutOfSync = () =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.onTimelineOutOfSync.match),
      throttleTime(200),
      concatMap(_ =>
        of(
          Actions.watchTimelineUpdates(), // Resubscribe to timeline updates.
          Actions.getCurrentTimelineData()
        ),
      )
    )

export default onTimelineOutOfSync()
